import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Tabs, Tab } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import SignIn from './SignIn';
import SignUp from './SignUp';
import { useEffect, useState } from "react";

const Login = ({ flowType, onClose, showRoomPopUp, tabName }) => {

  const [activeTab, setActiveTab] = useState('signin');
  useEffect(() => {
    if (tabName) {
      setActiveTab(tabName);
    }
  }, [tabName])

  const handleSignupSuccess = () => {
    setActiveTab('signin'); // Switch to Sign In tab
  };

  return (
    <>
      <div className='bodyTabWrap'>
        <div className="pt-5 tabWrap">
          <Tabs defaultActiveKey="signin" id="tabs-example" className="justify-content-md-center" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
            <Tab eventKey="signin" title="Sign In" className='signInTab'>
              <SignIn
                onClose={onClose}
                flowType={flowType}
                showRoomPopUp={showRoomPopUp}
                isActive={activeTab === 'signin'} />
            </Tab>
            <Tab eventKey="signup" title="Sign Up" className='signUpTab'>
              <SignUp
                onSignupSuccess={handleSignupSuccess}
                isActive={activeTab === 'signup'}
              />
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
}
export default Login;